module.exports = __webpack_public_path__ + "static/media/editIcon.411e094c.svg";